import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { BaseService } from 'src/app/core/services/base.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-invoice-create-credit-note-dialog',
  templateUrl: './invoice-create-credit-note-dialog.component.html',
  styleUrls: ['./invoice-create-credit-note-dialog.component.scss']
})
export class InvoiceCreateCreditNoteDialogComponent implements OnInit {
  stores: any[] = [];
  warehouses: any[] = [];
  reasons: any[] = [];
  lines = [];
  storeId: number = null;
  warehouseCode: string = null;
  approvedByEmail: string = null;
  approvedByPwd: string = null;

  constructor(
    private dialogRef: MatDialogRef<InvoiceCreateCreditNoteDialogComponent>,
    private dialog: MatDialog,
    private baseService: BaseService,
    private helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) public data: {
      invoiceNumber: string;
      salesOrderNumber: string;
      lines: any[];
    },
  ) { }

  ngOnInit() {
    this.lines = JSON.parse(JSON.stringify((this.data.lines || []).filter(f => f.allowedToReturnQty > 0)));
    this.lines.forEach(l => {
      l.returnQty = 0;
      l.returnReasonCode = null;
    });

    this.baseService.executeCommand<any>('portal_syspro_invoice_create_credit_note_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.reasons = response.data.reasons;
          this.stores = response.data.stores;
          if (this.stores && this.stores.length === 1) {
            this.storeId = this.stores[0].storeId;
            this.storeChanged(null);
          }
        }
      });
  }

  storeChanged(event: MatSelectChange) {
    this.warehouses = [];
    this.warehouseCode = null;

    if (this.storeId) {
      const selectedStore = this.stores.find(f => f.storeId === this.storeId);
      if (selectedStore && selectedStore.warehouses) {
        this.warehouses = selectedStore.warehouses || [];
        if (this.warehouses.length === 1) {
          this.warehouseCode = this.warehouses[0].warehouseCode;
        }
      } 
    }
  }

  createCreditNote() {

    const dialogData: OiGroupDialogData = {
      title: 'Creating Invoice',
      function: 'portal_oi_group_invoice_create_credit_note',
      postBody: {
        invoiceNumber: this.data.invoiceNumber,
        salesOrderNumber: this.data.salesOrderNumber,
        storeId: this.storeId,
        warehouseCode: this.warehouseCode,
        approvedByEmail: this.approvedByEmail,
        approvedByPwd: this.helperService.hash(this.approvedByPwd),
        lines: this.lines.filter(f => f.returnQty > 0).map(m => {
          return {
            invoiceLine: m.invoiceLine,
            returnQty: m.returnQty,
            returnReasonCode: m.returnReasonCode
          };
        }),
      }
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.dialogRef.close(true);
      }
    });
  }

  get valid(): boolean {
    if (!this.storeId || !this.approvedByEmail || !this.approvedByPwd) {
      return false;
    }

    const returnLines = this.lines.filter(f => f.returnQty > 0);
    if (returnLines.length === 0) {
      return false;
    }

    if (returnLines.filter(f => f.returnReasonCode === null).length > 0) {
      return false;
    }

    return true;
  }

  arrayOfNumbers(n: number): number[] {
    return Array.from(Array(n + 1).keys());
  }
}
